<template>
<div @click="tt"></div>
</template>
<script>
export default {
  data(){
    return{
      ageList:[]
    }
  },
  methods:{
    tt(){
this.$emit('ageListEvent', this.ageList)
    }
  },
  created(){

let list=JSON.parse(sessionStorage.getItem("list"))
console.log(list)
if(!list){
  this.ageList=[]
}else{
if(!list.city){
    this.ageList=[{
        value:"",
        label:"选择年龄段",
      },{
        value:"1",
        label:"70岁以下",
      },{
        value:"2",
        label:"70岁以上",
      },{
        value:"3",
        label:"70-79岁",
      },{
        value:"4",
        label:"80岁以下",
      },{
        value:"5",
        label:"80岁以上",
      },{
        value:"6",
        label:"80-84岁",
      },{
         value:"7",
         label:"80-89岁",
      },{
        value:"8",
        label:"85-99岁",
     },{
        value:"9",
        label:"90-99岁",
     },{
        value:"10",
        label:"100岁以上",
     }]
}
else if(list.city.split(',')[1]=="延安市"){
    this.ageList=[{
        value:"",
        label:"选择年龄段",                           
      },{
        value:"1",
        label:"70岁以下",
      },{
        value:"2",
        label:"70岁以上",
      },{
        value:"3",
        label:"70-79岁",
      },{
         value:"7",
         label:"80-89岁",
      },{
        value:"9",
        label:"90-99岁",
     },{
        value:"10",
        label:"100岁以上",
     }]
}else if(list.city.split(',')[1]=="潍坊市"){
    this.ageList=[{
        value:"",
        label:"选择年龄段",
      },{
        value:"4",
        label:"80岁以下",
      },{
        value:"5",
        label:"80岁以上",
      },{
         value:"7",
         label:"80-89岁",
      },{
        value:"9",
        label:"90-99岁",
     },{
        value:"10",
        label:"100岁以上",
     }]
}else if(list.city.split(',')[1]=="衡水市"){
    this.ageList=[{
        value:"",
        label:"选择年龄段",
      },{
        value:"4",
        label:"80岁以下",
      },{
        value:"5",
        label:"80岁以上",
      },{
        value:"6",
        label:"80-84岁",
      },{
        value:"8",
        label:"85-99岁",
     },{
        value:"10",
        label:"100岁以上",
     }]
}else if(list.city.split(',')[1]=="廊坊市"){
  this.ageList=[{
      value:"",
      label:"选择年龄段",
    },{
      value:"4",
      label:"80岁以下",
    },{
      value:"5",
      label:"80岁以上",
    },{
      value:"6",
      label:"80-84岁",
    },{
      value:"11",
      label:"85-89岁",
   },{
    value:"12",
    label:"90-94岁",
  },{
  value:"13",
  label:"95-99岁",
  },{
      value:"8",
      label:"85-99岁",
   },{
      value:"10",
      label:"100岁以上",
   }]
}else{
    this.ageList=[{
        value:"",
        label:"选择年龄段",
      },{
        value:"4",
        label:"80岁以下",
      },{
        value:"5",
        label:"80岁以上",
      },{
         value:"7",
         label:"80-89岁",
      },{
        value:"9",
        label:"90-99岁",
     },{
        value:"10",
        label:"100岁以上",
     }]
}


}
this.tt()
}
}

//export default ageList
</script>


// WEBPACK FOOTER //
// src/utils/ageList.vue